import { clsx } from 'clsx';
import styles from './DocsLoadingShimmer.module.scss';
import { getDataIdGenerator } from '../../../shared/utils/dataId';

const SHIMMER_FIELDS = [
  {
    id: 'f1',
    fields: [
      { id: 'i1f1', item: 'sm' },
      { id: 'i2f1', item: 'lg' },
      { id: 'i3f1', item: 'sm' }
    ]
  },
  {
    id: 'f2',
    fields: [
      { id: 'i1f2', item: 'sm' },
      { id: 'i2f2', item: 'lg' },
      { id: 'i3f2', item: 'sm' }
    ]
  }
];

export function DocsLoadingShimmer({ dataId }: { dataId: string }) {
  const dataIdGenerator = getDataIdGenerator(dataId, 'docs-loading-shimmer');

  return (
    <div className='row justify-center mx-5' data-id={dataIdGenerator('')}>
      {SHIMMER_FIELDS.map(field => (
        <div className='col-xs-12 mt-8' key={field.id}>
          {field.fields.map(item => (
            <div
              key={item.id}
              className={clsx(
                'shimmer shimmer-line mb-2',
                styles.shimmerItem,
                item.item === 'sm' ? styles.shimmerItemSmall : styles.shimmerItemLarge
              )}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
